import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueI18n from 'vue-i18n'
import './registerServiceWorker'
import StaticFileRepository from './repositories/staticFileRepository'
import { RepositoryFactory, Repositories } from './repositories/repositoryFactory'
import { ServiceFactory, Services } from './services/serviceFactory'
import { OpenIdConnectPlugin } from 'inuits-vuejs-oidc'
import MasterConfig from './models/config/masterConfig'
import BacComponents, { IBacComponentsOptions } from 'bac-frontend-common'
import TranslationModel from '@/models/translationModel'
// @ts-ignore
import VueOffline from 'vue-offline'

import './init/initFontAwesome'
import './styles/build.scss'

Vue.config.productionTip = false

// Load configuration json before starting and configuring vue and sentry
new StaticFileRepository().getFile('cfg/config.json')
  .then((configFile: any) => {

    // Deserialize config file so structure is certain
    configFile = new MasterConfig().deserialize(configFile)
    if (configFile.oidc && configFile.oidc.baseUrl && configFile.oidc.clientId) {
      Vue.use(OpenIdConnectPlugin, {
        store: store,
        router: router,
        configuration: {
          baseUrl: configFile.oidc.baseUrl,
          tokenEndpoint: configFile.oidc.tokenEndpoint ? configFile.oidc.tokenEndpoint : 'token',
          authEndpoint: configFile.oidc.authEndpoint ? configFile.oidc.authEndpoint : 'auth',
          logoutEndpoint: configFile.oidc.logoutEndpoint ? configFile.oidc.logoutEndpoint : 'logout',
          clientId: configFile.oidc.clientId,
          authorizedRedirectRoute: '/',
          serverBaseUrl: configFile.api.baseUrl,
          serverTokenEndpoint: 'api/oidc/v1/token',
          serverRefreshEndpoint: 'api/oidc/v1/refresh'
        }
      })
    }

    store.commit('setConfig', configFile)

    // Setup multilang
    Vue.use(VueI18n)

    // Load component library BAC
    let bacComponentsOptions: IBacComponentsOptions = {
      store
    }
    Vue.use(BacComponents, bacComponentsOptions)

    // Offline detection
    Vue.use(VueOffline)

    ServiceFactory.get(Services.Translation).getInitialJsonTranslations().then((translationModel: TranslationModel) => {
      const loggedIn = store.getters['openid/isLoggedIn']

      const i18n = new VueI18n({
        locale: 'en',
        fallbackLocale: 'en',
        messages: translationModel.translations
      })

      // Add router before guard that gets additional api translations if logged in
      router.beforeEach((to: any, from: any, next: any) => {
        if (to.matched.some((record: any) => record.meta.requiresOpenIdAuth)) {
          if (store.getters['openid/isLoggedIn']) {
            ServiceFactory.get(Services.Translation).loadAdditionalApiTranslations(i18n).then(() => {
              next()
            })
          } else {
            next()
          }
        } else {
          next()
        }
      })

      new Vue({
        router,
        store,
        i18n,
        render: h => h(App)
      }).$mount('#app')
    })

  })
